import { gql } from '@apollo/client/core';
import type { PartnerMemberAllowanceBalancesPage } from '@/models/PartnerMemberAllowanceBalances';
import { queryExecute } from '@/Utils/graphqlAPI';

const FETCH_SUBSIDY_ALLOWANCE_BALANCES = gql`
  query FetchSubsidyAllowanceBalances(
    $partnerCodeName: String!
    $callerId: String
    $phoneNumber: String
    $page: Int
    $limit: Int
    $latestPastBudgetCount: Int
  ) {
    fetchSubsidyAllowanceBalances(
      partnerCodeName: $partnerCodeName
      callerId: $callerId
      phoneNumber: $phoneNumber
      page: $page
      limit: $limit
      latestPastBudgetCount: $latestPastBudgetCount
    ) {
      members {
        callerId
        fullName
        phoneNumber
        balances {
          id
          subsidyAllowanceId
          partnerId
          callerId
          amount
          overrideRenewAmount
          startBudgetAmount
          beginningDate
          suspensionDate
          preAuthorizationNumber
          subsidyAllowance {
            id
            allowanceName
            kind
            renewAmount
            isPartnerLevel
            budgetLimit
            isPreAuthorizationNumberRequired
          }
        }
      }
      totalCount
      totalPages
      currentPage
    }
  }
`;

export const fetchSubsidyAllowanceBalances = async ({
  partnerCodeName,
  callerId,
  phoneNumber,
  page = 1,
  limit = 30,
  latestPastBudgetCount,
}: {
  partnerCodeName: string;
  callerId?: string;
  phoneNumber?: string;
  page?: number;
  limit?: number;
  latestPastBudgetCount?: number;
}) => {
  const response = await queryExecute<{ fetchSubsidyAllowanceBalances: PartnerMemberAllowanceBalancesPage }>({
    query: FETCH_SUBSIDY_ALLOWANCE_BALANCES,
    variables: {
      partnerCodeName,
      callerId,
      phoneNumber: phoneNumber?.trim() || undefined,
      page,
      limit,
      latestPastBudgetCount,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data?.fetchSubsidyAllowanceBalances ?? null;
};
